<template>
  <div id="locations">
    <div class="row">
      <div class="reportSection">
        <section-heading>
          <div slot="title">Locations</div>
        </section-heading>
      </div>
    </div>
    <div class="row" v-for="location in locations" :key="location.id">
      <transition name="fade">
        <div class="col-md-12" v-show="showLocations">
          <location :report="report" :location="location" v-on:on-change="onChange"></location>
        </div>
      </transition>
    </div>
    <div class="sectionBreak row"></div>
    <div class="panel panel-default summaryPanel">
      <div class="panel-heading">
        <div class="row">
          <div class="col-xs-12">
            <h5>Add another location</h5>
            <p>
              You can add additional UK locations to this company, these will then be included in
              this report and all future reports you run on this company.
            </p>
          </div>
        </div>
        <validation-observer class="panel-body" ref="observer" tag="div" v-slot="{ invalid }">
          <div class="row">
            <div class="form-group col-xs-3">
              <label for="locationPostcode" class="control-label">Postcode</label>
              <validation-provider mode="lazy" rules="required|valid_postcode" v-slot="{ errors }">
                <input
                  type="text"
                  class="form-control"
                  id="locationPostcode"
                  v-model="locationPostcode"
                  placeholder="UK Postcode"
                  name="postcode"
                  required
                />
                <span class="text-danger field-validation-error">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="form-group col-xs-7">
              <label for="locationLabel" class="control-label">Label</label>
              <validation-provider mode="lazy" rules="required|min:5|max:80" v-slot="{ errors }">
                <input
                  type="text"
                  class="form-control"
                  id="locationLabel"
                  v-model="locationLabel"
                  placeholder="A short piece of text that describes this location"
                  name="location label"
                  required
                />
                <span class="text-danger field-validation-error">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="form-group col-xs-2 text-right" style="margin-top: 20px">
              <button
                type="button"
                id="addLocation"
                class="btn btn-success"
                v-on:click="addLocation"
                :disabled="invalid"
              >
                Add location
              </button>
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import SectionHeading from '@/components/reports/components/SectionHeading';
import Location from '@/components/reports/panels/Location';
import Axios from '@/packages/axios/Axios';

export default {
  components: {
    SectionHeading,
    Location,
  },
  props: ['report', 'showDiff', 'diffData'],
  data() {
    return {
      showLocations: true,
      locationPostcode: '',
      locationLabel: '',
    };
  },
  methods: {
    onChange(value) {
      this.showLocations = false;
      this.$emit('on-change', value.companyoverview.locations);
      this.showLocations = true;
    },
    addLocation() {
      Axios.post('/v1/customlocations', {
        postcode: this.locationPostcode,
        label: this.locationLabel,
        report_id: this.report.id,
      })
        .then((response) => {
          this.onChange(response.data[0]);
          this.locationPostcode = null;
          this.locationLabel = null;
          this.$nextTick(() => {
            this.$refs.observer.reset();
          });
        })
        .catch((e) => {
          if (e.response) {
            this.errors.push(e);
            switch (e.response.status) {
              case 401:
                this.$router.push('/error/401');
                break;
              case 403:
                this.$router.push('/error/403');
                break;
              case 404:
                this.$router.push('/error/404');
                break;
              default:
                this.$router.push('/error/unknown');
            }
          }
        });
    },
  },
  computed: {
    locations() {
      return this.report.companyoverview.locations;
    },
  },
  watch: {
    report(newValue) {
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
